export default __webpack_public_path__ + "static/media/fuelEnDetailRompetrolTablet.431d1d3a.jpg";